// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.demo-phone-link {
  margin: 0 0 12px;
  padding: 12px 12px 10px;
  border-radius: 14px;
  background: rgba(8, 119, 188, 0.08);
  border: 1px solid rgba(8, 119, 188, 0.22);
}

.demo-phone-link__title {
  margin: 0 0 4px;
  font-size: 0.92rem;
  font-weight: 700;
}

.demo-phone-link__hint {
  margin: 0 0 8px;
  font-size: 0.8rem;
  line-height: 1.4;
  opacity: 0.82;
}

.demo-phone-link__qr-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}

.demo-phone-link__qr {
  display: block;
  width: min(220px, 100%);
  height: auto;
  border-radius: 12px;
  background: #fff;
  padding: 8px;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.12);
}

.demo-phone-link--compact .demo-phone-link__qr {
  width: min(180px, 100%);
  padding: 6px;
}

.demo-phone-link--fullscreen {
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  text-align: center;
}

.demo-phone-link--fullscreen .demo-phone-link__hint {
  font-size: clamp(0.9rem, 2.8vw, 1.05rem);
  line-height: 1.45;
  margin-bottom: 16px;
  opacity: 0.92;
}

.demo-phone-link--fullscreen .demo-phone-link__qr-wrap {
  margin-bottom: 16px;
}

.demo-phone-link--fullscreen .demo-phone-link__qr {
  width: min(85vmin, 480px);
  max-width: 100%;
  padding: clamp(10px, 2vmin, 16px);
  border-radius: 16px;
}

.demo-phone-link--fullscreen .demo-phone-link__code {
  font-size: clamp(0.95rem, 2.5vw, 1.1rem);
  margin-bottom: 16px;
}

.demo-phone-link--fullscreen .demo-phone-link__code strong {
  font-size: clamp(1.35rem, 4vmin, 1.75rem);
}

.demo-phone-link--fullscreen .demo-phone-link__actions {
  max-width: 420px;
  margin: 0 auto;
}

.demo-phone-link--fullscreen .demo-phone-link__btn {
  min-height: 44px;
  font-size: 0.95rem;
}

.demo-guest-qr-overlay {
  position: fixed;
  inset: 0;
  z-index: 10050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: max(16px, env(safe-area-inset-top)) max(16px, env(safe-area-inset-right))
    max(16px, env(safe-area-inset-bottom)) max(16px, env(safe-area-inset-left));
  background: rgba(15, 23, 42, 0.94);
  backdrop-filter: blur(10px);
}

.demo-guest-qr-overlay__panel {
  position: relative;
  width: min(560px, 100%);
  max-height: 100%;
  overflow: auto;
  padding: 20px 18px 18px;
  border-radius: 20px;
  background: linear-gradient(165deg, #0f172a 0%, #1e293b 100%);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: #f8fafc;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.45);
}

.demo-guest-qr-overlay__close {
  position: absolute;
  top: 10px;
  right: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 0;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  color: inherit;
  cursor: pointer;
}

.demo-guest-qr-overlay__title {
  margin: 0 48px 12px 0;
  font-size: 1.15rem;
  font-weight: 700;
  text-align: center;
}

.demo-guest-qr-overlay__hide-btn {
  display: block;
  width: 100%;
  min-height: 44px;
  margin-top: 4px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 12px;
  background: transparent;
  color: inherit;
  font-size: 0.95rem;
  font-weight: 650;
  cursor: pointer;
}

.demo-guest-qr-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 36px;
  padding: 8px 12px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 0.82rem;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.06);
  color: inherit;
  flex-shrink: 0;
}

.demo-guest-qr-toggle--active {
  background: rgba(8, 119, 188, 0.35);
  border-color: rgba(8, 119, 188, 0.55);
}

.demo-guest-invite__qr-open {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 42px;
  margin-bottom: 10px;
  border: 1px dashed rgba(8, 119, 188, 0.45);
  border-radius: 12px;
  background: rgba(8, 119, 188, 0.08);
  color: inherit;
  font-size: 0.88rem;
  font-weight: 650;
  cursor: pointer;
}

.lt-coach-dash .demo-guest-qr-toggle {
  border-color: rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.06);
}

.lt-coach-dash .demo-guest-qr-toggle--active {
  background: rgba(8, 119, 188, 0.35);
  border-color: rgba(8, 119, 188, 0.55);
}

.demo-phone-link__code {
  margin: 0 0 8px;
  font-size: 0.82rem;
  opacity: 0.9;
}

.demo-phone-link__code strong {
  font-size: 1rem;
  letter-spacing: 0.08em;
}

.demo-phone-link__actions {
  display: flex;
  gap: 8px;
}

.demo-phone-link__btn {
  flex: 1 1;
  min-height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 0;
  border-radius: 10px;
  background: #0877bc;
  color: #fff;
  font-size: 0.82rem;
  font-weight: 650;
  cursor: pointer;
}

.demo-phone-link__btn--share {
  background: transparent;
  color: inherit;
  border: 1px solid rgba(8, 119, 188, 0.35);
}

.lt-pp-sheet .demo-phone-link {
  background: rgba(8, 119, 188, 0.1);
}

.lt-coach-dash .demo-phone-link {
  margin: 0 0 10px;
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.12);
  color: inherit;
}

.lt-coach-dash .demo-phone-link__btn--share {
  border-color: rgba(255, 255, 255, 0.2);
}

.demo-guest-invite {
  margin: 0 0 12px;
  border-radius: 14px;
  border: 1px solid rgba(8, 119, 188, 0.22);
  background: rgba(8, 119, 188, 0.06);
  overflow: hidden;
}

.demo-guest-invite__toggle {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 44px;
  padding: 10px 12px;
  border: 0;
  background: transparent;
  color: inherit;
  font-size: 0.9rem;
  font-weight: 700;
  text-align: left;
  cursor: pointer;
}

.demo-guest-invite__chevron {
  transition: transform 0.2s ease;
  opacity: 0.75;
}

.demo-guest-invite--open .demo-guest-invite__chevron {
  transform: rotate(180deg);
}

.demo-guest-invite__body {
  padding: 0 12px 12px;
}

.demo-guest-invite__body .demo-phone-link {
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
}

.lt-coach-dash .demo-guest-invite {
  margin: 0 0 10px;
  background: rgba(255, 255, 255, 0.04);
  border-color: rgba(255, 255, 255, 0.12);
}
`, "",{"version":3,"sources":["webpack://./src/components/DemoPhoneJoinLink.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;+EAC6E;EAC7E,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,6DAA6D;EAC7D,2CAA2C;EAC3C,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,mCAAmC;EACnC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,uCAAuC;AACzC","sourcesContent":[".demo-phone-link {\n  margin: 0 0 12px;\n  padding: 12px 12px 10px;\n  border-radius: 14px;\n  background: rgba(8, 119, 188, 0.08);\n  border: 1px solid rgba(8, 119, 188, 0.22);\n}\n\n.demo-phone-link__title {\n  margin: 0 0 4px;\n  font-size: 0.92rem;\n  font-weight: 700;\n}\n\n.demo-phone-link__hint {\n  margin: 0 0 8px;\n  font-size: 0.8rem;\n  line-height: 1.4;\n  opacity: 0.82;\n}\n\n.demo-phone-link__qr-wrap {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 8px;\n}\n\n.demo-phone-link__qr {\n  display: block;\n  width: min(220px, 100%);\n  height: auto;\n  border-radius: 12px;\n  background: #fff;\n  padding: 8px;\n  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.12);\n}\n\n.demo-phone-link--compact .demo-phone-link__qr {\n  width: min(180px, 100%);\n  padding: 6px;\n}\n\n.demo-phone-link--fullscreen {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  text-align: center;\n}\n\n.demo-phone-link--fullscreen .demo-phone-link__hint {\n  font-size: clamp(0.9rem, 2.8vw, 1.05rem);\n  line-height: 1.45;\n  margin-bottom: 16px;\n  opacity: 0.92;\n}\n\n.demo-phone-link--fullscreen .demo-phone-link__qr-wrap {\n  margin-bottom: 16px;\n}\n\n.demo-phone-link--fullscreen .demo-phone-link__qr {\n  width: min(85vmin, 480px);\n  max-width: 100%;\n  padding: clamp(10px, 2vmin, 16px);\n  border-radius: 16px;\n}\n\n.demo-phone-link--fullscreen .demo-phone-link__code {\n  font-size: clamp(0.95rem, 2.5vw, 1.1rem);\n  margin-bottom: 16px;\n}\n\n.demo-phone-link--fullscreen .demo-phone-link__code strong {\n  font-size: clamp(1.35rem, 4vmin, 1.75rem);\n}\n\n.demo-phone-link--fullscreen .demo-phone-link__actions {\n  max-width: 420px;\n  margin: 0 auto;\n}\n\n.demo-phone-link--fullscreen .demo-phone-link__btn {\n  min-height: 44px;\n  font-size: 0.95rem;\n}\n\n.demo-guest-qr-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 10050;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: max(16px, env(safe-area-inset-top)) max(16px, env(safe-area-inset-right))\n    max(16px, env(safe-area-inset-bottom)) max(16px, env(safe-area-inset-left));\n  background: rgba(15, 23, 42, 0.94);\n  backdrop-filter: blur(10px);\n}\n\n.demo-guest-qr-overlay__panel {\n  position: relative;\n  width: min(560px, 100%);\n  max-height: 100%;\n  overflow: auto;\n  padding: 20px 18px 18px;\n  border-radius: 20px;\n  background: linear-gradient(165deg, #0f172a 0%, #1e293b 100%);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  color: #f8fafc;\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.45);\n}\n\n.demo-guest-qr-overlay__close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border: 0;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.08);\n  color: inherit;\n  cursor: pointer;\n}\n\n.demo-guest-qr-overlay__title {\n  margin: 0 48px 12px 0;\n  font-size: 1.15rem;\n  font-weight: 700;\n  text-align: center;\n}\n\n.demo-guest-qr-overlay__hide-btn {\n  display: block;\n  width: 100%;\n  min-height: 44px;\n  margin-top: 4px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  border-radius: 12px;\n  background: transparent;\n  color: inherit;\n  font-size: 0.95rem;\n  font-weight: 650;\n  cursor: pointer;\n}\n\n.demo-guest-qr-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-height: 36px;\n  padding: 8px 12px;\n  border-radius: 8px;\n  font-weight: 700;\n  font-size: 0.82rem;\n  cursor: pointer;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  background: rgba(255, 255, 255, 0.06);\n  color: inherit;\n  flex-shrink: 0;\n}\n\n.demo-guest-qr-toggle--active {\n  background: rgba(8, 119, 188, 0.35);\n  border-color: rgba(8, 119, 188, 0.55);\n}\n\n.demo-guest-invite__qr-open {\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 42px;\n  margin-bottom: 10px;\n  border: 1px dashed rgba(8, 119, 188, 0.45);\n  border-radius: 12px;\n  background: rgba(8, 119, 188, 0.08);\n  color: inherit;\n  font-size: 0.88rem;\n  font-weight: 650;\n  cursor: pointer;\n}\n\n.lt-coach-dash .demo-guest-qr-toggle {\n  border-color: rgba(255, 255, 255, 0.18);\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.lt-coach-dash .demo-guest-qr-toggle--active {\n  background: rgba(8, 119, 188, 0.35);\n  border-color: rgba(8, 119, 188, 0.55);\n}\n\n.demo-phone-link__code {\n  margin: 0 0 8px;\n  font-size: 0.82rem;\n  opacity: 0.9;\n}\n\n.demo-phone-link__code strong {\n  font-size: 1rem;\n  letter-spacing: 0.08em;\n}\n\n.demo-phone-link__actions {\n  display: flex;\n  gap: 8px;\n}\n\n.demo-phone-link__btn {\n  flex: 1;\n  min-height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  border: 0;\n  border-radius: 10px;\n  background: #0877bc;\n  color: #fff;\n  font-size: 0.82rem;\n  font-weight: 650;\n  cursor: pointer;\n}\n\n.demo-phone-link__btn--share {\n  background: transparent;\n  color: inherit;\n  border: 1px solid rgba(8, 119, 188, 0.35);\n}\n\n.lt-pp-sheet .demo-phone-link {\n  background: rgba(8, 119, 188, 0.1);\n}\n\n.lt-coach-dash .demo-phone-link {\n  margin: 0 0 10px;\n  background: rgba(255, 255, 255, 0.06);\n  border-color: rgba(255, 255, 255, 0.12);\n  color: inherit;\n}\n\n.lt-coach-dash .demo-phone-link__btn--share {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.demo-guest-invite {\n  margin: 0 0 12px;\n  border-radius: 14px;\n  border: 1px solid rgba(8, 119, 188, 0.22);\n  background: rgba(8, 119, 188, 0.06);\n  overflow: hidden;\n}\n\n.demo-guest-invite__toggle {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  min-height: 44px;\n  padding: 10px 12px;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font-size: 0.9rem;\n  font-weight: 700;\n  text-align: left;\n  cursor: pointer;\n}\n\n.demo-guest-invite__chevron {\n  transition: transform 0.2s ease;\n  opacity: 0.75;\n}\n\n.demo-guest-invite--open .demo-guest-invite__chevron {\n  transform: rotate(180deg);\n}\n\n.demo-guest-invite__body {\n  padding: 0 12px 12px;\n}\n\n.demo-guest-invite__body .demo-phone-link {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  background: transparent;\n}\n\n.lt-coach-dash .demo-guest-invite {\n  margin: 0 0 10px;\n  background: rgba(255, 255, 255, 0.04);\n  border-color: rgba(255, 255, 255, 0.12);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
